import { render, staticRenderFns } from "./autocomplete.vue?vue&type=template&id=79b137e1&"
import script from "./autocomplete.vue?vue&type=script&lang=ts&"
export * from "./autocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports